import { NpStarsWithCount } from "src/components/np-design/components/NpStarsWithCount"
import { useProductContext } from "src/components/product-details/context"

export const ProductRating = () => {
  const { rating } = useProductContext()

  if (!rating) {
    return null
  }

  return <NpStarsWithCount {...rating} />
}
